import { Fragment } from "react"
import { ReactComponent as Spinner } from './three-dots.svg';
import './style.css'

const ProgressSpinner = (props) => {
    const classNames = props.className + ' spinner';
    return (
        <Fragment>
            <div className={classNames}>
                <div className="background"></div>
                <div className="wrapper" style={{ marginTop: '20%' }}>
                    <Spinner />
                </div>
            </div>
        </Fragment>
    )
}

export default ProgressSpinner;